import React, { useState, useEffect } from "react";
import { Stack, Typography, Autocomplete, TextField } from "@mui/material";
import ClientListShell from "../Shell/ClientListShell.jsx";
import useFetchAgentsOptions from "../../../sharedhooks/Agents/useFetchAllAgents.js";

export default function AdminClientList() {
	const [currentAgent, setCurrentAgent] = useState(null);
	const { agents, loading: agentOptionsLoading } = useFetchAgentsOptions();

	useEffect(() => {
		if (agents?.length > 0 && !currentAgent) {
			setCurrentAgent(agents[0]);
		}
	}, [agents, currentAgent]);

	const header = (
		<Stack
			direction={"row"}
			alignItems={{ xs: "center !important", sm: "center" }}
			justifyContent={{ xs: "space-between !important" }}
			gap={{ xs: 5, sm: 2 }}
			width={{ xs: "100%", lg: "auto" }}
		>
			<Stack direction={{ xs: "column", lg: "row" }} alignItems={"center"} flex={1} gap={1}>
				<Typography fontWeight={600} sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>
					Current Agent:
				</Typography>
				<Autocomplete
					size="small"
					options={agents || []}
					loading={agentOptionsLoading}
					value={currentAgent}
					onChange={(e, newValue) => setCurrentAgent(newValue)}
					getOptionLabel={(option) => option?.display_name || ""}
					isOptionEqualToValue={(option, value) => option?.ID === value?.ID}
					sx={{
						width: { xs: "100%", sm: 220, md: 250 },
						"& .MuiButtonBase-root": {
							backgroundColor: "transparent",
							"&:hover": { color: "#1D54A2" },
						},
					}}
					slotProps={{
						popper: {
							sx: {
								"& .MuiAutocomplete-paper": { width: "inherit !important" },
							},
						},
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							placeholder="Select agent"
							sx={{
								"& .MuiInputBase-input": {
									padding: { xs: "6px 10px", sm: "8.5px 14px" },
									fontSize: { xs: 13, sm: 14 },
								},
								"& fieldset": { borderColor: "#4E4E4E !important" },
								"&:hover fieldset": { borderColor: "#4E4E4E !important" },
								"&.Mui-focused fieldset": { borderColor: "#4E4E4E !important" },
								"& .MuiAutocomplete-input": { border: "none !important" },
							}}
						/>
					)}
				/>
			</Stack>

			<Stack direction={{ xs: "column", lg: "row" }} alignItems={"center"} flex={1} gap={1}>
				<Typography fontWeight={600} sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>
					NPN:
				</Typography>
				<Typography sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>{currentAgent?.npn_number || "N/A"}</Typography>
			</Stack>
		</Stack>
	);

	return <ClientListShell userId={currentAgent?.ID} headerSlot={header} emptyText={"No policy found. Try selecting other agent"} />;
}
